module Sm.Core.FractionalOrder

open Sm.Core.Option

module private Bindings =
    open Fable.Core.JsInterop

    let BASE_62_DIGITS: string = importMember "./fractional.js"
    let INTEGER_ZERO: string = importMember "./fractional.js"

    let validateOrderKey(key: string): unit = importMember "./fractional.js"
    let generateKeyBetween(a: string, b: string, digits: string) : string = importMember "./fractional.js"

type Order = private Order of string
let (|OrderString|) (Order value) = value

module private Impl =
    let create value = Order value

    let between a b =
        try
            match Bindings.generateKeyBetween(a, b, Bindings.BASE_62_DIGITS) with
            | null -> None
            | x -> Some x
        with _
            -> None

    let isValid s =
        try Bindings.validateOrderKey(s); true
        with _ -> false

let parse s =
    if Impl.isValid s then Some (Impl.create s)
    else None

let increment (Order value) =
    maybe {
        let! next = Impl.between value null
        return Impl.create next
    }

let decrement (Order value) =
    maybe {
        let! prev = Impl.between null value
        return Impl.create prev
    }

let midpoint (Order a) (Order b) =
    maybe {
        let! x = Impl.between a b
        return Impl.create x
    }

let (|Order|_|) = parse

let zero = Impl.create Bindings.INTEGER_ZERO
let one = zero |> increment |> Option.get

type Order with
    static member Zero = zero
    static member One = one
    member x.Increment () = increment x
    member x.Decrement () = decrement x
    member a.MidpointTo b = midpoint a b

module OrderSeq =
    let from (start: Order) = seq {
        let mutable x = Some start
        while x.IsSome do 
            x.Value
            x <- x |> Option.bind increment
    }
